import { CallApi } from '@signavio/kraken'
import { schema as schemas } from 'normalizr'
import qs from 'qs'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'adminOrganizationTypedLicenses'

export const schema = new schemas.Array(new schemas.Entity(collection))

/**
 * Will return licenses based on their type and organization.
 * E.g. org:wolfpack, type: enterprise will return all licenses from the wolf pack that have the type enterprise
 */
export const fetch =
  (callApi: CallApi) =>
  (
    {
      organizationId,
      licenseType,
    }: { organizationId: string; licenseType: string },
    _: unknown,
    requestParameters: object
  ) =>
    callApi(
      `${ADMIN_API_BASE}/organizations/${organizationId}/licenses/type/${licenseType}${qs.stringify(
        { ...requestParameters },
        { addQueryPrefix: true, arrayFormat: 'brackets' }
      )}`,
      schema
    )

export const update =
  (callApi: CallApi) =>
  (
    {
      organizationId,
      licenseType,
    }: { organizationId: string; licenseType: string },
    body: object
  ) => {
    return callApi(
      `${ADMIN_API_BASE}/organizations/${organizationId}/licenses/type/${licenseType}/editAll`,
      schema,
      { method: 'PUT', body }
    )
  }
